import { Box } from "@mui/material";

import { BackButton, FlexBoxRow, NextButton } from "components/atoms";
import { palette } from "theme/palette";

type Props = {
  backHandle: () => void;
  nextHandle: () => void;
  disableBackButton: boolean;
  nextButtonText?: string;
  disableNextButton?: boolean;
};

const FormControlButtons = ({
  backHandle,
  nextHandle,
  disableBackButton,
  nextButtonText = "Next",
  disableNextButton = false,
}: Props) => {
  return (
    <Box
      sx={{
        width: "fit-content",
        backgroundColor: palette.white,
        position: "sticky",
        bottom: "32px",
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: "16px",
        boxShadow:
          "rgba(0, 0, 0, 0.2) 0px 6px 6px -3px, rgba(0, 0, 0, 0.14) 0px 10px 14px 1px, rgba(0, 0, 0, 0.12) 0px 4px 18px 3px",
      }}
    >
      <FlexBoxRow
        styleProps={{
          padding: "16px",
          justifyContent: "center",
        }}
        notColumnOnMobile
      >
        <BackButton
          onClick={backHandle}
          disableBackButton={disableBackButton}
        />
        <NextButton
          onClick={nextHandle}
          nextButtonText={nextButtonText}
          disabled={disableNextButton}
        />
      </FlexBoxRow>
    </Box>
  );
};

export default FormControlButtons;
